const handleStats = () => {
  const statElements = document.querySelectorAll('[data-stats]')

  statElements.forEach((stat) => {
    const suffix = stat.getAttribute('data-stats-suffix')
    const count = parseInt(stat.innerHTML, 10)

    if (!count) return

    let currCount = 0
    const incrementAmount = count / 100

    const setCount = (): void => {
      if (currCount >= count) return clearInterval(countInterval())

      currCount += incrementAmount

      if (suffix) {
        stat.innerHTML = `${Math.floor(
          currCount,
        ).toString()} <div>${suffix}</div>`
      } else {
        stat.innerHTML = Math.floor(currCount).toString()
      }
    }

    const countInterval = () => setInterval(setCount, 30)

    countInterval()
  })
}

export default handleStats
